import  { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PageLoader from '../../../../components/PageLoader';
import GlobalDODAgencyComponent from '../components/global-dod-agency-component';
import { useAppDispatch } from '../../../../hooks/hooks';
import { selectGlobalDodAgencyMappingQueryItems } from '../../../../redux/dod-agency-mapping/selector';
import { globalDodAgencyMapping } from '../../../../redux/dod-agency-mapping/action';
import { channelPrograms } from '../../../../redux/channel-program/action';
import { dodProgramParticipants } from '../../../../redux/dod-program-participants/action';
import { selectDodProgramParticipantsListItems } from '../../../../redux/dod-program-participants/selector';
import { selectChannelProgramsListItems } from '../../../../redux/channel-program/selector';

const GlobalDODAgencyMapping  = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const GlobalDodAgencyMappingQuery = useSelector(selectGlobalDodAgencyMappingQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
    const participantsData = useSelector(selectDodProgramParticipantsListItems)
      const itemsData = useSelector(selectChannelProgramsListItems)
  const [
    selectedGlobalDODMapping,
    setSelectedGlobalDODMapping
  ] = useState<any>({})


  const fetchChannelProgramById = () => {
     dispatch(globalDodAgencyMapping.query({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn/global-dod-agency-mappings/fetch-detail`,
      entity: 'globalOrgRegistrations',
      jsonData: {
        Records: [
          {
            Id: parmas?.id,
           
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedGlobalDODMapping({ ...selectedGlobalDODMapping, [field]: event });
  }

  useEffect(
    () => {
       
                      dispatch(channelPrograms.list({
      url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dod-cloud/channel-management/global-channel-programs/fetch`,
      entity: 'channelPrograms',
      jsonData: {
       "Context" :{},
       "Records" :
       [
        {}
       ]
      }
    })).then(() => {
        dispatch(dodProgramParticipants.list({
      url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dod-cloud/channel-management/global-dod-program-participants/fetch`,
      entity: 'dodProgramParticipants',
      jsonData: {
       "Context" :{},
       "Records" :
       [
        {}
       ],
        Pagination:{
      }
      }
    }))})

            if (parmas?.id > 0) {
                fetchChannelProgramById()
                setIsLoading(false)
              }else {
                setIsLoading(false)
              }
           
          
    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setSelectedGlobalDODMapping(GlobalDodAgencyMappingQuery?.result?.items)
      }
    },
    [isQuery]
  )

 

  const back = () => {
    navigate(`/dbn/global-dod-agency-mapping`)
  }


  return (
    <>
      {isLoading ? <PageLoader /> :
        <GlobalDODAgencyComponent
          selectedGlobalDODMapping={selectedGlobalDODMapping}
          handleInnerFormChange={handleInnerFormChange}
          back={back}
           dodProgramParticipants={participantsData?.result?.items}
            channelPrograms={itemsData?.result?.items}
            id={parmas?.id}
        />
      }
    </>
  )

}

export default GlobalDODAgencyMapping ;